import BathBodySection from './BathBodySection';

export default BathBodySection;
